export default {

  UPDATE_ISLOADING: (state, data) => { state.isLoading = data },

  SET_LOCALIZATIONS: (state, data) => { state.localizations = data },
  SET_LOCALIZATION: (state, data) => { state.localization = data },
  SET_PAGINATION: (state, data) => { const { items, ...p } = data; state.pagination = p },

  UPDATE_FILTER: (state, data) => {
    state.filters.params[data.propKey] = data.value
  },
  RESET_FILTER: state => {
    const filteri = {
      params: {
        page: 1,
        take: 10,
        search: '',
        order: 'desc',
      },
    }
    state.filters = filteri
  },
  SET_LOCALIZATION_OPTIONS: (state, data) => { state.localizationOptions = data },
  SET_PLAYERS_LOCALIZATIONS: (state, data) => { state.playerLocalizations = data },
  UPDATE_LOCALIZATION_VALUE: (state, { name, value }) => {
    const item = state.localization?.localizations?.find(loc => loc.name === name)
    if (item) {
      item.value = value
    }
  },

}
